/**
 * HTTP client configuration constants
 */
export const HTTP_CONFIG = {
  TIMEOUT_MS: 30000, // 30 seconds
  TOAST_AUTO_CLOSE_MS: 5000, // 5 seconds
} as const;
